export default __webpack_public_path__ + "static/media/PolySansTrial-Median.73b8f136.otf";